import { DesignClass, ObjectClass } from "@app/types";
import React from "react";
import ReactDOM from "react-dom";
import VariableDataModel from "../../models/VariableDataModel";
import ModuleNodeModel from "../../models/ModuleNodeModel";
import PropertyPanelWidget from "../PropertyPanelWidget";
import PromptNodeModel from "../../models/nodes/PromptNodeModel";

export default class BlankElementEmbed extends React.Component {
    state = { tempNode: undefined }

    componentDidMount() {
        const tempNode = this.initTempNode();
        this.setState({ tempNode })
    }

    onChange = (tempNode)=> this.setState({ tempNode })

    /**
     * Initialize dummy data model
     */
    initTempNode = () => {
        if (this.props.type === "variable"){
            let tempNode = new VariableDataModel();
            tempNode.isEmbed = true;
            if (this.props.nodeName) {
                tempNode.setConfig("varName", this.props.nodeName);
            }

            return tempNode;
        }
        if (this.props.type === "module"){
            return new ModuleNodeModel();
        }
        if (this.props.type === "prompt"){
            let tempNode = new PromptNodeModel(this.props.nodeName);
            tempNode.setConfig("repeatable", true);
            // set as application component to avoid variable removal by BaseNodeModel.removeVariableRefs
            tempNode.setWriteProxy(() => true);
            return tempNode
        }
    }

    /**
     * Convert data model to serialized format
     * @returns {Object}
     */
    compile() {
        const { tempNode } = this.state;
        if (this.props.type === "variable"){
            return {
                "id": tempNode.getID(),
                "name": tempNode.getConfig("name"),
                "type": "variable",
                "_class": DesignClass.variable,
                "props": tempNode.props
            };
        }
        if (this.props.type === "module"){
            return {
                "id": tempNode.getID(),
                "name": tempNode.getConfig("name"),
                "type": "module",
                "_class": DesignClass.module,
                "props": tempNode.props,
                "version": 1,
                "versions": {
                    1: {
                        "version": 1,
                        "flow": {
                            "offsetX": 0,
                            "offsetY": 0,
                            "zoom": 100,
                            "links": [],
                            "nodes": [
                                {
                                    "id": "65200c36-5b78-4c57-be36-90b9f8acba5a",
                                    "_class": ObjectClass.begin,
                                    "x": 340,
                                    "y": 200,
                                    "name": "Begin",
                                    "props": {
                                        "colorClass": "purple",
                                        "iconClass": "log-in",
                                        "error": {},
                                        "config": {
                                            "description": "Entry point of the module"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                },
                "localVariables":[]
            };
        }
        if (this.props.type === "prompt"){
            return tempNode.serialize();
        }
    }

    render() {
        const { tempNode } = this.state;
        return tempNode ? (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            <label>{window.l.popup.create_new_space + this.props.type}</label>
                        </div>
                        <div className="col-md-12">
                            <PropertyPanelWidget
                                embed
                                context={tempNode}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                </div>
                <div className={"element-buttons"}>
                    <button className={"w2ui-btn secondary"} onClick={() => {
                        w2popup.message();
                        ReactDOM.unmountComponentAtNode($(".blank_container").get(0));
                    }}>{window.l.popup.close}
                    </button>
                    <button className={"w2ui-btn primary"} onClick={() => {
                        if (!tempNode.hasError()) {
                            const newNode = this.props.addFunc($('#tl_container'), this.compile(),false, null,this.props.coOrdinates);
                            // jsTree data updated, need to refresh the tree
                            window.apm.refreshApplicationTree();
                            ReactDOM.unmountComponentAtNode($(".blank_container").get(0));
                            w2popup.close();
                            if(newNode) {
                                window.apm.postEventToCurrentView({
                                    target: "request-component-panel",
                                    event: newNode,
                                    shouldFocusInput: true,
                                });
                            }
                        } else {
                            alert(window.l.popup.fix_error);
                        }
                    }}>{window.l.popup.add}
                    </button>
                </div>
            </div>
        ) : <></>;
    }
}